import { useEffect, useState } from "react";
import useAxios from "../../../../hooks/useAxios";
import Constants from "../../../../Constants";
import { getDashboardFilterQueryString } from "../../../../utils/helper";
import { useCompanyFilterContext } from "../../components/context/CompanyFilterContext";

export const useCompaniesCredit = () => {
    const { filterParams } = useCompanyFilterContext();
    const { selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies } = filterParams;
    const { getData, isLoading } = useAxios();

    const [creditedCompanies, setCreditedCompanies] = useState([]);
    const [totalCreditCount, setTotalCreditCount] = useState(0);

    useEffect(() => {
        const fetchInactiveCompanies = async () => {
            const baseUrl = Constants.ApiUrl.super.dashboard;
            const query = getDashboardFilterQueryString({ selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies });

            try {
                const response = await getData(`${baseUrl.totalCreditCharged}?${query}`);
                if (response?.success) {
                    setCreditedCompanies(response?.data?.items || []);
                    setTotalCreditCount(response?.data?.allCompaniesTotalCredit || 0);
                }
            } catch (err) {
                console.error("Failed to fetch inactive companies", err);
                setCreditedCompanies([]);
                setTotalCreditCount(0);
            }
        };

        fetchInactiveCompanies();
    }, [selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies]);

    return {
        isCreditLoading: isLoading,
        totalCreditCount,
        creditedCompanies,
    };
};
